import React from 'react';
import {
  gridFilteredTopLevelRowCountSelector,
  gridFilterModelSelector,
  gridRowSelectionCountSelector,
  useGridApiContext,
  useGridSelector
} from '@mui/x-data-grid-premium';

import './PatientDatabaseFooter.scss';

export const PatientDatabaseFooter = ({ totalRowCount }) => {
  const apiRef = useGridApiContext();
  const filteredRowCount = useGridSelector(apiRef, gridFilteredTopLevelRowCountSelector);
  const filterModel = useGridSelector(apiRef, gridFilterModelSelector);
  const selectedRowCount = useGridSelector(apiRef, gridRowSelectionCountSelector);

  const hasAnyFilters =
    filterModel.items.some(item => item.value != null && item.value !== '') ||
    filterModel.quickFilterValues?.length > 0;
  const showFilteredCount = hasAnyFilters && filteredRowCount !== totalRowCount;

  return (
    <div className="patient-database-footer" data-testid="patient-database-footer">
      {selectedRowCount > 0 && (
        <span className="patient-database-footer__selected-count" data-testid="patient-database-footer-selected-count">
          {`Total Rows Selected: ${selectedRowCount}`}
        </span>
      )}
      <span className="patient-database-footer__total-count" data-testid="patient-database-footer-total-count">
        {showFilteredCount ? `Total Rows: ${filteredRowCount} of ${totalRowCount}` : `Total Rows: ${totalRowCount}`}
      </span>
    </div>
  );
};
